import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import { DEFAULT_TOKEN_DECIMALS, MARGINX_BRANDING } from "./shared";

// ============================================
// OPTIMISM TESTNET (Chain ID: 11155420)
// ============================================
export const optimismTestnetConfig: ChainConfig = {
  chainId: ChainIdEnum.OPTIMISM_TESTNET,
  name: "Optimism Sepolia Testnet",
  shortName: "op-sepolia",
  isTestnet: true,
  rpcUrls: ["https://sepolia.optimism.io"],
  explorerUrl: "https://sepolia-optimism.etherscan.io",
  l2ExplorerUrl: "https://basecamp.cloud.blockscout.com",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  tokenDecimals: DEFAULT_TOKEN_DECIMALS,
  contracts: {
    erc20: {
      usdc: "0x6D290609b3F5F02D52F28d97C75a443ED8564cBf",
      "usdc-native": "0x6D290609b3F5F02D52F28d97C75a443ED8564cBf",
      usdt: "",
      weth: "0x2b42AFFD4b7C14d9B7C2579229495c052672Ccd3",
      wbtc: "",
      l2usdc: "0x52623B37Ff81c53567D6D16fd94638734cCDCf27",
      l2usdt: "",
      l2weth: "0x80626896A2ad4a8ba69a93C4a519C23be26dD403",
      l2wbtc: "",
      govToken: "",
    },
    multichain: {
      socketHelper: "0x09F62d9f9fe489c2CD460D7Be8E78d4ACE0a8e60",
      vault: {
        usdc: "0x8537307810fC40F4073A12a38554D4Ff78EfFf41",
        "native-usdc": "0x8537307810fC40F4073A12a38554D4Ff78EfFf41",
        weth: "0x57D1Aeafb6a2b7Bd4954e47a556622161A8c0A65",
      },
      connector: {
        usdc: "0x565810cbfa3Cf1390963E5aFa2fB953795686339",
        "native-usdc": "0x565810cbfa3Cf1390963E5aFa2fB953795686339",
        weth: "0xaa3d9fA3aB930aE635b001d00C612aa5b14d750e",
      },
      withdrawalConnector: {
        usdc: "0xb584D4bE1A5470CA1a8778E9B86c81e165204599",
        "native-usdc": "0xb584D4bE1A5470CA1a8778E9B86c81e165204599",
        weth: "0x7050b6f947BA48508219Ac02EC152E9f198ADc5e",
      },
      l2WithdrawProxy: "0x80bd95726009997A36d29A8e2Ba71B1a996F8E04",
    },
  },
  signingDomain: { name: "MarginX Optimism Testnet", version: "1" },
  socketL2ChainId: 11155112,
  branding: MARGINX_BRANDING,
};
